/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
 */
export interface FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice {
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    LocalizedPrice: string;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    Price: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    PriceBeforeDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    PriceDiscount: number;
    /**
     * 
     * @type {number}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    PriceBeforeBeautify: number;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    CurrencySymbol: string;
    /**
     * 
     * @type {string}
     * @memberof FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice
     */
    CurrencyIso4217: string;
}

/**
 * Check if a given object implements the FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice interface.
 */
export function instanceOfFxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice(value: object): value is FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice {
    if (!('LocalizedPrice' in value) || value['LocalizedPrice'] === undefined) return false;
    if (!('Price' in value) || value['Price'] === undefined) return false;
    if (!('PriceBeforeDiscount' in value) || value['PriceBeforeDiscount'] === undefined) return false;
    if (!('PriceDiscount' in value) || value['PriceDiscount'] === undefined) return false;
    if (!('PriceBeforeBeautify' in value) || value['PriceBeforeBeautify'] === undefined) return false;
    if (!('CurrencySymbol' in value) || value['CurrencySymbol'] === undefined) return false;
    if (!('CurrencyIso4217' in value) || value['CurrencyIso4217'] === undefined) return false;
    return true;
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice {
    if (json == null) {
        return json;
    }
    return {
        
        'LocalizedPrice': json['localized_price'],
        'Price': json['price'],
        'PriceBeforeDiscount': json['price_before_discount'],
        'PriceDiscount': json['price_discount'],
        'PriceBeforeBeautify': json['price_before_beautify'],
        'CurrencySymbol': json['currency_symbol'],
        'CurrencyIso4217': json['currency_iso4217'],
    };
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSON(json: any): FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice {
    return FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSONTyped(json, false);
}

export function FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPriceToJSONTyped(value?: FxIdApplicationHandlersNativeStatusNativeStatusDtoStoreFrontProductPrice | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'localized_price': value['LocalizedPrice'],
        'price': value['Price'],
        'price_before_discount': value['PriceBeforeDiscount'],
        'price_discount': value['PriceDiscount'],
        'price_before_beautify': value['PriceBeforeBeautify'],
        'currency_symbol': value['CurrencySymbol'],
        'currency_iso4217': value['CurrencyIso4217'],
    };
}

